import React, { useContext } from 'react'
import { Api } from '../contexts/Api'
import { AddBox, Check, Delete, ElectricMoped, LocalShipping, ShoppingCart, Store, UpdateTwoTone } from '@mui/icons-material';
import { Pagination } from '@mui/material';

function TimeLineList() {
    const { logs, logsCount, logsPageCount, handleLogsFill } = useContext(Api);
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card custom-card">
                    <div className="card-header">
                        <div className="card-title">
                            Timeline
                        </div>
                    </div>
                    <div className="card-body">
                        <ul className="notification">
                            {logs && logs.map(log => (
                                <li>
                                    <div className="notification-time">
                                        <span className="time">{log.time}</span>
                                    </div>
                                    <div className="notification-icon">
                                        <span className="avatar avatar-lg p-1 border border-primary border-opacity-25 rounded-pill">
                                            <span className="avatar avatar-md avatar-rounded bg-primary-transparent svg-primary">
                                                {(() => {
                                                    switch (log.type) {
                                                        case "Product":
                                                            return <ShoppingCart />; // Müvafiq ikon
                                                        case "Order":
                                                            return <LocalShipping />; // Müvafiq ikon
                                                        default:
                                                            return <Store />; // Default ikon
                                                    }
                                                })()}
                                            </span>
                                        </span>
                                    </div>
                                    <div className="notification-body">
                                        <span>{log.who}</span>
                                        <div className="d-flex align-items-start gap-3 flex-wrap p-3 rounded bg-light">
                                            <div>
                                                {(() => {
                                                    switch (log.status) {
                                                        case "Check":
                                                            return (
                                                                <span className="avatar avatar-lg bg-primary">
                                                                    <Check />
                                                                </span> // Müvafiq ikon
                                                            );
                                                        case "Update":
                                                            return (
                                                                <span className="avatar avatar-lg bg-warning">
                                                                    <UpdateTwoTone />
                                                                </span> // Müvafiq ikon
                                                            );
                                                        case "Delete":
                                                            return (
                                                                <span className="avatar avatar-lg bg-danger">
                                                                    <Delete />
                                                                </span> // Müvafiq ikon
                                                            );  // Müvafiq ikon
                                                        case "Create":
                                                            return (
                                                                <span className="avatar avatar-lg bg-success">
                                                                    <AddBox />
                                                                </span> // Müvafiq ikon
                                                            );  // Müvafiq ikon
                                                        default:
                                                            return (
                                                                <span className="avatar avatar-lg bg-">
                                                                    <Check />
                                                                </span> // Müvafiq ikon
                                                            ); // Default ikon
                                                    }
                                                })()}
                                                <span className="avatar avatar-lg bg-">
                                                    <Check />
                                                </span>
                                            </div>
                                            <div className="flex-fill w-50">
                                                <h5 className="mb-1 fs-15 fw-medium text-dark">Event: {log.title}</h5>
                                                <p className="mb-0 text-muted">{log.description}</p>
                                            </div>
                                            <div>
                                                {(() => {
                                                    switch (log.status) {
                                                        case "Check":
                                                            return (
                                                                <span className="badge bg-primary">
                                                                    {log.date}
                                                                </span> // Müvafiq ikon
                                                            );
                                                        case "Update":
                                                            return (
                                                                <span className="badge bg-warning">
                                                                    {log.date}
                                                                </span> // Müvafiq ikon
                                                            );
                                                        case "Delete":
                                                            return (
                                                                <span className="badge bg-danger">
                                                                    {log.date}
                                                                </span> // Müvafiq ikon
                                                            );  // Müvafiq ikon
                                                        case "Create":
                                                            return (
                                                                <span className="badge bg-success">
                                                                    {log.date}
                                                                </span> // Müvafiq ikon
                                                            );  // Müvafiq ikon
                                                        default:
                                                            return (
                                                                <span className="badge bg-primary">
                                                                    {log.date}
                                                                </span> // Müvafiq ikon
                                                            ); // Default ikon
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div className="d-flex justify-content-center">

                            <Pagination onChange={(event, value) => handleLogsFill('page', value)} className='justify-content' count={logsPageCount} variant="outlined" color="primary" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default TimeLineList